import AutoSuggest from "./autoSuggestWrapper.jsx";
import BaseComponent from "../../../baseComponent.js"
import DatasetService from "../../../../core/services/datasetService.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator.js";
import DataProfileDetail from "./dataProfileDetail.jsx";
import Licenses from "./licenses.jsx";
import CheckBox from "../../../common/check-box/checkBox.jsx";
import styles from "../../../common/modal.scss";

export default class CreateDataset extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
  }

  getDefaultState() {
    return {
      page: 1,
      suggestions: [],
      dataProfileSearchValue: "",
      dataProfileDetail: null,
      reset: true,
      dataset: {
        name: "",
        description: "",
        dataProfile: null,
        subscriptionPrice: 0,
        isPublic: false,
      },
      licenses: [this.getEmptyLicense()],
      validity: {
        name: "",
        dataProfile: "",
        subscriptionPrice: "",
        license: ""
      }
    }
  }

  componentDidMount() {
    this.loadDataProfiles();
    this.$modal = $("#create-dataset-modal");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    this.$modal.modal("open");
  }

  getEmptyLicense() {
    return {
      description: "",
      dataAccessAge: 0,
      cost: 0,
      persistenceId: UniqueIdGenerator.uuid()
    }
  }

  hideProfileDetail(event) {
    let isOpen = this.refs.dataProfileDetail.classList.contains("slide-in");
    if (isOpen) {
      event.preventDefault();
      event.stopPropagation();
      this.refs.dataProfileDetail.setAttribute("class", "slide-out");
    }
  }

  openProfileDetail(dataProfile) {
    this.setState({dataProfile});
    let isOpen = this.refs.dataProfileDetail.classList.contains("slide-in");
    if (!isOpen) {
      this.refs.dataProfileDetail.setAttribute("class", "slide-in");
    }
  }

  next() {
    if (this.validate()) {
      this.refs.tab1.setAttribute("class", "slide-out-reverse");
      this.setState({
        page: 2
      });
    }
  }

  previous() {
    this.refs.tab1.setAttribute("class", "slide-in-reverse");
    this.setState({
      page: 1
    });
  }

  toggleDataProfileDetail() {
    let isOpen = this.refs.dataProfileDetail.classList.contains("slide-in");
    this.refs.dataProfileDetail.setAttribute("class", isOpen ? "slide-out" : "slide-in");
  }

  loadDataProfiles() {
    DatasetService.getAllDataProfiles((res) => {
      this.dataProfiles = res.data;
    });
  }

  create() {
    if (this.validate()) {
      this.publish(InternalEvent.App.SHOW_PRELOADER);
      let dataset = this.state.dataset;
      dataset.dataProfile = dataset.dataProfile.persistenceId;
      DatasetService.createDataset(dataset)
        .then(dataset => {
          return this.createLicenses(dataset.persistenceId);
        })
        .then(licenseCreated => {
          this.reset();
          this.publish(InternalEvent.App.HIDE_PRELOADER);
          if (licenseCreated) {
            this.publish(InternalEvent.Databank.DATASET_CREATED);
          }
          setTimeout(() => {
            this.$modal.modal("close");
          }, 200);
        });
    }
  }

  createLicenses(datasetId) {
    let numberOfLicense = 0;
    let numberOfResponses = 0;

    let licensesToCreate = this.state.licenses.filter(license => {
      // remove temporary added persistenceId id for tracking
      delete license.persistenceId;
      license.dataset = datasetId;
      return license.description.length > 0;
    });

    return new Promise(resolve => {
      if (licensesToCreate.length > 0) {
        licensesToCreate.forEach(license => {
          DatasetService.createDatasetLicense(license)
            .then(response => {
              numberOfResponses++;
              if (numberOfResponses === numberOfLicense) {
                resolve(true);
              }
            });
          numberOfLicense++;
        });
      } else {
        resolve(false);
      }
    });
  }

  reset() {
    let state = this.getDefaultState();
    this.setState(state);
    this.resetValidity();
    this.$modal.modal("close");
    this.refs.tab1.setAttribute("class", "");
  }

  validate() {
    let valid = true;
    let dataset = this.state.dataset;
    let validity = this.state.validity;

    if (dataset.name.trim().length === 0) {
      valid = false;
      validity.name = "invalid";
    }

    if (dataset.dataProfile == null) {
      valid = false;
      validity.dataProfile = "invalid";
      $(this.refs.dataProfile).find("input").addClass("invalid");
    }

    for (let i = 0; i < this.state.licenses.length; i++) {
      this.state.licenses[i].dataAccessAge = parseInt(this.state.licenses[i].dataAccessAge);
      this.state.licenses[i].cost = parseInt(this.state.licenses[i].cost);
    }

    this.setState({
      validity: validity
    });

    return valid;
  }

  resetValidity() {
    this.setState({
      validity: {
        name: "",
        dataProfile: "",
        subscriptionPrice: ""
      }
    });
    $(this.refs.dataProfile).find("input").removeClass("invalid");
  }

  handleLicenseChanged(license) {
    let isNew = true;
    let licenses = this.state.licenses.slice();
    for (let i = 0; i < licenses.length; i++) {
      if (licenses[i].persistenceId === license.persistenceId) {
        licenses[i] = license;
        isNew = false;
        break;
      }
    }

    if (isNew) {
      licenses.push(license);
    }

    this.setState({
      licenses: licenses
    });
  }

  handleAddBtnClicked() {
    let licenses = this.state.licenses.slice();
    licenses.push(this.getEmptyLicense());
    this.setState({
      licenses: licenses
    });
  }

  handleRemoveBtnClicked(licenseId) {
    let licenses = this.state.licenses.slice();
    for (let i = 0; i < licenses.length; i++) {
      if (licenses[i].persistenceId === licenseId) {
        licenses.splice(i, 1);
        break;
      }
    }
    this.setState({
      licenses: licenses
    });
  }

  handleInputChange(event, fieldName) {
    let dataset = this.state.dataset;
    let validity = this.state.validity;
    dataset[fieldName] = event.target.value;
    validity[fieldName] = "";
    this.setState({
      dataset: dataset,
      validity: validity
    });

    if (fieldName === "dataProfile") {
      $(this.refs.dataProfile).find("input").removeClass("invalid");
    }
  }

  handleCheckboxClick(value, fieldName) {
    this.state.dataset[fieldName] = !value;
    this.setState(this.state);
  }

  response(value) {
    this.setState(value);
  }

  render() {


    let btns = [];

    if (this.state.page === 1) {
      btns.push(<button className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')} key="0" onClick={e => this.reset(e)}>Cancel</button>);
      btns.push(<button className={[styles.actionButton, "btn waves-effect"].join(' ')} key="1" onClick={e => this.next(e)}>Next</button>);
    } else {
      btns.push(<button className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')} key="2" onClick={e => this.previous(e)}>Previous</button>);
      btns.push(<span style={{flex: 1}} key="3"/>);
      btns.push(<button className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')} key="4" onClick={e => this.reset(e)}>Cancel</button>);
      btns.push(<button className={[styles.actionButton, "btn waves-effect"].join(' ')} key="5" onClick={e => this.create(e)}>Create</button>);
    }

    return (
      <div id="create-dataset-modal" className={[styles.modal, "modal"].join(' ')} style={{width: 550}}>
        <div className="modal-wrapper" onMouseDown={(e) => this.hideProfileDetail(e)}>
          <div className="modal-content">
            <div ref="tab1" style={{zIndex: 1, overflowY: "auto"}}>
              <h5>Create Dataset</h5>
              <div className="row" style={{margin: '0 -1.4rem'}}>
                <form className="col s12">
                  <div className="row">
                    <div className="input-field col s12">
                      <input id="dataset_name" type="text" className={this.state.validity.name}
                             value={this.state.dataset.name}
                             onChange={e => this.handleInputChange(e, "name")}/>
                      <label htmlFor="dataset_name">Dataset Name</label>
                    </div>
                  </div>
                  <div className="row" ref="dataProfile">
                    <AutoSuggest data={this.state} openProfileDetail={this.openProfileDetail} callback={this.response}/>
                  </div>
                  <div className="row">
                    <div className="input-field col s12">
                      <textarea id="dataset_description" className="materialize-textarea"
                                value={this.state.dataset.description}
                                onChange={e => this.handleInputChange(e, "description") }/>
                      <label htmlFor="dataset_description">Description</label>
                    </div>
                  </div>
                  <div className="row">
                    <CheckBox text="Private" value={!this.state.dataset.isPublic}
                              onChange={value => this.handleCheckboxClick(value, "isPublic")}/>
                  </div>
                </form>
              </div>
            </div>
            <div ref="tab2">
              <h5>Licenses</h5>
              <div className="row" style={{margin: '0 -0.7rem'}}>
                <form className="col s12">
                  <div className="row">
                    <Licenses licenses={this.state.licenses}
                              onAddBtnClicked={() => this.handleAddBtnClicked()}
                              onRemoveBtnClicked={licenseId => this.handleRemoveBtnClicked(licenseId)}
                              onLicenseChanged={license => this.handleLicenseChanged(license)}/>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className={styles.footer} >
            {btns}
          </div>
        </div>
        <div id="data-profile-detail" ref="dataProfileDetail">
          <DataProfileDetail dataProfile={this.state.dataProfile}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/create/dataset/createDataset.jsx